import React from "react";
import styled from "styled-components";

/**
 * 게임 하나에 대한 이야기 묶음.
 *
 * 본문 칸을 벗어나 화면 가로를 꽉 채우는 색 띠로 그린다. 색은 그 게임의 키 비주얼에서
 * 가져온 값이고(src/content/newsletters/games.js), 띠 안의 글은 본문과 같은 칸에
 * 그대로 놓인다. 게임이 바뀌면 띠 색이 바뀌므로 어디서 이야기가 넘어가는지 한눈에 보인다.
 *
 * 띠는 본문 칸(가운데 정렬)을 기준으로 좌우를 뷰포트 끝까지 늘리고, 같은 폭만큼
 * 안쪽 여백을 줘서 글의 좌우 위치는 그대로 둔다.
 */
function GameSection({ game, children }) {
  return (
    <Section style={{ "--nl-game-bg": game.bg, "--nl-accent": game.accent }}>
      <Head>
        {game.logo ? (
          <Title>
            <Logo
              src={game.logo.src}
              alt={game.title}
              style={{ height: game.logo.height }}
            />
          </Title>
        ) : (
          <Title>{game.title}</Title>
        )}
        {game.genre ? <Genre>{game.genre}</Genre> : null}
      </Head>
      {children}
    </Section>
  );
}

const Section = styled.section`
  margin: 3.5rem 0;
  margin-left: calc(50% - 50vw);
  margin-right: calc(50% - 50vw);
  padding: 3.5rem calc(50vw - 50%) 2.5rem;
  background: var(--nl-game-bg);

  /* 게임 띠끼리는 맞닿게 둔다 — 사이에 흰 틈이 있으면 상자를 늘어놓은 것처럼 보인다. */
  & + & {
    margin-top: -3.5rem;
  }

  > *:last-child {
    margin-bottom: 0;
  }
`;

const Head = styled.header`
  margin-bottom: 1.75rem;
`;

const Title = styled.h2`
  margin: 0;
  font-size: 1.875rem;
  font-weight: 800;
  line-height: 1.3;
  letter-spacing: -0.03em;
  color: var(--nl-ink);

  @media screen and (max-width: 768px) {
    font-size: 1.625rem;
  }
`;

/* 로고는 세로 높이를 게임별로 지정하고 가로는 비율대로. 좁은 화면에서는 폭에 맞춰 줄어든다. */
const Logo = styled.img`
  display: block;
  max-width: 100%;
  width: auto;
  object-fit: contain;
  object-position: left center;
`;

const Genre = styled.p`
  margin: 0.375rem 0 0;
  font-size: 0.9375rem;
  font-weight: 500;
  line-height: 1.6;
  color: var(--nl-accent);
`;

export default GameSection;
